import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

export default function PageHeader({ eyebrow, title, subtitle, breadcrumb }) {
  return (
    <section className="bg-[#0B192C] text-white border-b border-[#1E3E62]" data-testid="page-header">
      <div className="cnl-container py-16 md:py-20 lg:py-24">
        {breadcrumb && (
          <nav className="flex items-center gap-2 text-[12px] text-gray-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors" data-testid="breadcrumb-home">
              Home
            </Link>
            <ChevronRight size={12} />
            <span className="text-gray-300">{breadcrumb}</span>
          </nav>
        )}
        {eyebrow && (
          <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-300">
            {eyebrow}
          </span>
        )}
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.05] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-[16px] lg:text-[17px] leading-relaxed text-gray-300 max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
